<form [formGroup]="formMain" (ngSubmit)="actionForm()" (reset)="resetModel()" name="{{formName}}" class="sas-dynamic-form" novalidate>
  <!--   <div ng-switch on="'{{$ctrl.type}}'" class="button-container" ng-if="$ctrl.topButton && !$ctrl.options.formState.readMode">
    <div ng-switch-when="search">
      <sas-button sas-id="btnSearchTop" disabled="$ctrl.formName.$invalid" type="search" text="{{$ctrl.text}}" class="submit sas-button" />
      <span class="sas-separator-white-space"></span>
      <div class="sas-button-container sas-button-container-float-right">
        <input type="reset" class="btn btn-primary sas-reset-btn" value="{{'Reset' | translate}}"
               ng-click="$ctrl.resetModel(ev)" />
      </div>
    </div>
    <div ng-switch-when="save">
      <sas-button disabled="form.$invalid" type="save" text="{{$ctrl.text}}" class="submit" />
      <span class="sas-separator-white-space" ng-if="$ctrl.extraButton !== undefined"></span>
      <sas-button ng-if="$ctrl.extraButton !== undefined"
                  text="{{$ctrl.extraButtonText}}"
                  sas-on-click="$ctrl.extraButtonAction(ev)">
    </div>
    <div ng-switch-when="delete">
      <sas-button type="delete" text="{{$ctrl.text}}" disabled="$ctrl.formName.$invalid" />
    </div>
    <div ng-switch-default>
    </div>
  </div> -->
  <fieldset>
    <!-- to add to the fieldset ng-disabled="$ctrl.options.formState.readMode" -->
    <legend></legend>
    <formly-form [form]="formMain" [model]="sasModel" [fields]="formFields" [options]="options" (modelChange)="onFormModelChange()" remove-role>
    </formly-form>
    <!-- <form [formGroup]="myform" (ngSubmit)="onSubmit()">
    <formly-form [form]="myform" [fields]="fields" [model]="myFormModel"></formly-form>
    <button type="submit" class="btn btn-default">Submit</button>
  </form> -->
    <!-- <div ng-switch on="'{{$ctrl.type}}'" class="button-container" ng-if="!$ctrl.options.formState.readMode">
    <div ng-switch-when="search">
      <sas-button sas-id="btnSearch" disabled="$ctrl.formName.$invalid" type="search" text="{{$ctrl.text}}" class="submit sas-button" />
      <span class="sas-separator-white-space"></span>
      <div class="sas-button-container sas-button-container-float-right">
        <input type="reset" class="btn btn-primary sas-reset-btn" value="{{'Reset' | translate}}"
               ng-click="$ctrl.resetModel(ev)" />
      </div>
    </div>
    <div ng-switch-when="save">
      <sas-button disabled="form.$invalid" type="save" text="{{$ctrl.text}}" class="submit" />
      <span class="sas-separator-white-space" ng-if="$ctrl.extraButton !== undefined"></span>
      <sas-button ng-if="$ctrl.extraButton !== undefined"
                  class="sas-dynamic-form-extra-button"
                  text="{{$ctrl.extraButtonText}}"
                  sas-on-click="$ctrl.extraButtonAction(ev)">
    </div>
    <div ng-switch-when="delete">
      <sas-button type="delete" text="{{$ctrl.text}}" disabled="$ctrl.formName.$invalid" />
    </div>
    <div ng-switch-default>
    </div>
  </div> -->
  </fieldset>
  <!-- br and buttons below to be replaced by the set of buttons above-->
  <br>
  <sas-button type="submit" text="Submit" customClass="me-3" sasId="sasDynamicFormSubmitBtn"></sas-button>
  <sas-button type="reset" text="Reset" sasId="sasDynamicFormResetBtn"></sas-button>
  <!-- <button type="button" class="btn btn-default" (click)="options.resetModel()">Reset</button> -->
  <!-- <button type="button" class="btn btn-default" (click)="options.updateInitialValue()">Update Intial Values</button> -->
</form>
